"use strict";

exports.__esModule = true;

var _stringUtils = require("./stringUtils");

Object.keys(_stringUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _stringUtils[key]) return;
  exports[key] = _stringUtils[key];
});